const numbersRegExp = /^[\d|.|,]*$/;

export const parseStringToNumber = (string: string) => {
  if (!string || !string.match(numbersRegExp)) return 0;
  const number = string.replace(',', '.');
  return +number;
};
